import React from 'react';
import { ArrowUpRightIcon, StarIcon } from 'lucide-react';
import { googleReviews } from '../data/site';
export function HeroReviewCard() {
  return <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-334" data-mp="r1k7td2k0qj4">
      <div className="glass-light flex w-full max-w-[340px] items-center gap-5 rounded-[14px] p-5" data-id="element-335" data-mp="15tuh2f1jg6pl">
        <span className="font-display text-[40px] leading-none tracking-tight text-ink" data-id="element-336" data-mp="110i452681oco">
          {googleReviews.rating}
        </span>

        <span className="h-12 w-px bg-ink/10" aria-hidden="true" data-id="element-337" data-mp="1arwantwlbofb" />

        <span className="min-w-0" data-id="element-338" data-mp="1atp7yilbcwan">
          <span className="flex gap-0.5" aria-label={`Rated ${googleReviews.rating} out of 5 stars`} data-id="element-339" data-mp="1or5ia56qda7o">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} aria-hidden="true" className="h-3 w-3 fill-accent text-accent" data-id="element-340" data-mp="3qiigyci3ulva" data-mpi={i} />)}
          </span>
          <span className="mt-2 block text-[13.5px] font-medium text-ink" data-id="element-341" data-mp="2q7z82xig64bo">
            {googleReviews.count} Google reviews
          </span>
          <span className="mt-0.5 block text-[12.5px] text-ink/50" data-id="element-342" data-mp="2v8522kc6w2wx">
            From Miami Lakes patients
          </span>
        </span>
      </div>

      {/* TODO: swap for the official Google Business Profile review URL once supplied. */}
      <a href={googleReviews.url} target="_blank" rel="noreferrer" className="group inline-flex min-h-[44px] items-center gap-2 text-[14.5px] font-medium text-white" data-id="element-343" data-mp="341i0u2wxpyqx">
        <span className="nav-link" data-id="element-344" data-mp="3dzedx09fn3ro">Read our reviews on Google</span>
        <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4 text-accent transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" strokeWidth={1.75} data-id="element-345" data-mp="3ix62ples69rn" />
      </a>
    </div>;
}